let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gcFVv")).then(() => parcelRequire('dgby4'));